import { createCoreDictActions } from '@infotech/4sides-core-dictionaries'

import { CORE_URL } from 'api/constants'

export default createCoreDictActions([
  {
    name       : `object_class`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_object_class`,
    idAttribute: `code`,
    versionRule: `object_class`,
  },
  {
    name       : `issue_source`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_issue_source`,
    idAttribute: `code`,
    versionRule: `issue_source`,
  },
  {
    name       : `issue_category`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_issue_category`,
    idAttribute: `code`,
    versionRule: `issue_category`,
  },
  {
    name       : `issue_priority`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_issue_priority`,
    idAttribute: `code`,
    versionRule: `issue_priority`,
  },
  {
    name       : `grid_type`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_grid_type`,
    idAttribute: `code`,
    versionRule: `grid_type`,
  },
  {
    name       : `violation_type`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_violation_type`,
    idAttribute: `code`,
    versionRule: `violation_type`,
  },
  {
    name       : `district`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_district`,
    idAttribute: `okato`,
    versionRule: `district`,
  },
  {
    name       : `esuz_res`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_esuz_res`,
    idAttribute: `code`,
    versionRule: `esuz_res`,
  },
  {
    name       : `violation_reason`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_violation_reason`,
    idAttribute: `code`,
    versionRule: `violation_reason`,
  },
  {
    name       : `work_kind`,
    url        : `${CORE_URL}/reference-esz/ds/data/object/esz_work_kind`,
    idAttribute: `code`,
    versionRule: `work_kind`,
  },
])
